import React, { createContext, useRef, useState } from 'react'

import PropTypes from 'prop-types'
import { v4 as uuidv4 } from 'uuid'

import { getRedirectTypeLocalStorage } from '../helpers/localStorage'

export const DataContext = createContext()

export const DataProvider = ({ children }) => {
  const [steps, setSteps] = useState([
    {
      label: 'Identificación',
      stepId: 1,
      completed: false,
      disabled: false,
      subSteps: []
    },
    {
      label: 'Entrega',
      stepId: 2,
      completed: false,
      disabled: true,
      subSteps: [
        {
          label: 'Address',
          subStepId: 2.1,
          completed: false
        },
        {
          label: 'Method',
          subStepId: 2.2,
          completed: false
        },
        {
          label: 'Map',
          subStepId: 2.3,
          completed: false
        }
      ]
    },
    {
      label: 'Pago',
      stepId: 3,
      completed: false,
      disabled: true,
      subSteps: [
        {
          label: 'Method',
          subStepId: 3.1,
          completed: false
        },
        {
          label: 'Form',
          subStepId: 3.2,
          completed: false
        }
      ]
    }
  ])

  const [selectedShippingMethod, setSelectedShippingMethod] = useState(null)

  const [selectedServiceType, setSelectedServiceType] = useState({})

  const [deliveryInfo, setDeliveryInfo] = useState({}) // services

  const [currentStep, setCurrentStep] = useState(() => (getRedirectTypeLocalStorage() ? 3 : 1))

  const [userInfo, setUserInfo] = useState({
    email: '',
    names: '',
    phone: '',
    rut: '',
    saveData: false,
    isRegistered: false,
    encryptedData: ''
  })

  const [addressInfo, setAddressInfo] = useState({
    userAddress: '',
    aditionalInfo: '',
    region: '',
    district: '',
    price: '',
    deliveryType: '',
    courier: '',
    serviceType: '',
    sla: '',
    coords: null,
    manualDelivery: null,
    serviceName: '',
    requireShipping: true,
    isManualAddress: false,
    pickupPointName: ''
  })

  const [customerInfo, setCustomerInfo] = useState({})

  const [billingInfo, setBillingInfo] = useState({
    corporateName: '',
    category: '',
    corporateRut: '',
    corporatePhone: '',
    address: '',
    district: ''
  })

  const [showFinalLoader, setShowFinalLoader] = useState(false)
  const finalLoaderStartedAt = useRef(null)

  const [ecommerceInfo, setEcommerceInfo] = useState({
    cms: '',
    vtexOrderFormId: '',
    checkoutId: '',
    shopifyCurrentCheckout: {},
    domain: '',
    magentoQuoteId: '',
    currentUrl: '',
    loggedIn: false,
    siteCookies: ''
  })

  const [companyInfo, setCompanyInfo] = useState({
    logoUrl: '',
    primaryColor: '#394860',
    secondaryColor: '#00B7F9',
    companyName: '',
    userId: ''
  })

  const [cartData, setCartData] = useState({
    lines: [],
    subtotal: 0,
    total: 0,
    shippingCost: null,
    itemsCount: 0,
    totalWeight: 0,
    discount: 0,
    giftCard: { total: 0, applied: 0, cards: [] },
    isFreeShipping: false,
    couponFreeShipping: false,
    automaticFreeShipping: {},
    automaticFreeShippingSnapshot: null
  })

  const [isPickup, setIsPickup] = useState(false)

  const [isRefreshingDiscounts, setIsRefreshingDiscounts] = useState(false)

  const [isPosPaymentFlow, setIsPosPaymentFlow] = useState(false)

  const [isNewSession, setIsNewSession] = useState()

  const [posCredentialId, setPosCredentialId] = useState(null)

  const [posCourierPointId, setPosCourierPointId] = useState(null)

  const [pointsData, setPointsData] = useState({
    localPoints: [],
    pinflagPoints: [],
    localPointSelected: {},
    pinflagPointSelected: {}
  })

  const [cmsPaymentMethods, setCmsPaymentMethods] = useState([])

  const [configurations, setConfigurations] = useState({})

  const [cartNotes, setCartNotes] = useState('')

  const [isCartNotesActive, setIsCartNotesActive] = useState(false)

  const [giftNotes, setGiftNotes] = useState('')

  const [isGiftWrapping, setIsGiftWrapping] = useState(false)

  const [isEditingDiscountCode, setIsEditingDiscountCode] = useState(true)

  const [shopifyLocations, setShopifyLocations] = useState([])

  const [loaderInfo, setLoaderInfo] = useState([
    {
      imageUrls: ['https://did-you-know-image.s3.sa-east-1.amazonaws.com/woman-loader.png'],
      modelDesign: 'split',
      backgroundColor: '#F4F7FA',
      body: 'La generación X compra más online que los Baby Boomers y Millennials',
      title: 'Sabías que?'
    }
  ])

  const [isLoadingLoaderInfo, setIsLoadingLoaderInfo] = useState(true)

  const [isSummaryOpen, setIsSummaryOpen] = useState(false)

  const [discountInfo, setDiscountInfo] = useState({
    discountCodes: [],
    discountNotification: '',
    discountError: undefined,
    initialDiscounts: {
      discounts: [],
      applied: true
    }
  })

  const [isRemoved, setIsRemoved] = useState(false)

  const [isSaving, setIsSaving] = useState(true)

  const [isEditing, setIsEditing] = useState(false)

  const [isShowingMap, setIsShowingMap] = useState(false)

  const [isUserValidated, setIsUserValidated] = useState(false)

  const [isAddingAddress, setIsAddingAddress] = useState(false)

  const [cardsData, setCardsData] = useState([])

  const [count, setCount] = useState(0)

  const [oneClick, setOneClick] = useState(false)

  const [options, setOptions] = useState([])

  const [collectedScrapperInfo, setCollectedScrapperInfo] = useState({
    joined: [],
    privateMessages: [],
    paymentUrl: '',
    socketMessages: []
  })

  const [orderData, setOrderData] = useState({
    approvedPaymentUrl: '',
    defaultPaymentUrl: '',
    paymentOrderId: '',
    referenceId: '',
    rejectedPaymentUrl: ''
  })

  const [otpChannel, setOtpChannel] = useState('email')

  const [extraAttributesShopify, setExtraAttributesShopify] = useState({})

  const [abandonedCartData, setAbandonedCartData] = useState({
    email: '',
    names: '',
    phone: '',
    rut: '',
    address: '',
    city: '',
    state: '',
    delivery_instructions: ''
  })

  const [abandonedCart, setAbandonedCart] = useState(false)

  const [abandonedCartProductsWithoutStock, setAbandonedCartProductsWithoutStock] = useState([])

  const [paymentSuccessfulData, setPaymentSuccessfulData] = useState({
    isPaymentSuccessful: false,
    orderId: ''
  })

  const [clientMetaData, setClientMetaData] = useState({
    userAgent: '',
    ipAddress: ''
  })

  const [emptyCart, setEmptyCart] = useState(false)

  const [isProccessingPaymentLoader, setIsProccessingPaymentLoader] = useState(() => !!getRedirectTypeLocalStorage())

  const [isReturningFromPaymentRedirect, setIsReturningFromPaymentRedirect] = useState(() => !!getRedirectTypeLocalStorage())

  const [redirectReason, setRedirectReason] = useState('')

  const [redirectSuccess, setRedirectSuccess] = useState(null)

  const [earlyScraperResponse, setEarlyScraperResponse] = useState(null)

  const [isWaitingStepThree, setIsWaitingStepThree] = useState(false)

  const [scraperStartTime, setScraperStartTime] = useState(null)

  const [dataAndPaymentStateSetted, setDataAndPaymentStateSetted] = useState(false)

  const [encryptedMessage, setEncryptedMessage] = useState('')

  const [isProductSoldOut, setIsProductSoldOut] = useState(false)

  const [isShowingRedirectModal, setIsShowingRedirectModal] = useState(false)

  const [hasToRedirect, setHasToRedirect] = useState(false)

  const [redirectExtraData, setRedirectExtraData] = useState({ extraUserInfo: {}, extraAddressInfo: {}, reason: '' })

  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false)

  const [isUserVerified, setIsUserVerified] = useState(false)

  const [isOtpOneClickSent, setIsOtpOneClickSent] = useState(false)

  const [userOneClickToken, setUserOneClickToken] = useState(null)

  const [useOneClickStep, setUseOneClickStep] = useState(false)

  const [addressId, setAddressId] = useState(null)

  const [isDeliveryDataChanged, setIsDeliveryDataChanged] = useState(false)

  const [stockBreakdownReloadAttempts, setStockBreakdownReloadAttempts] = useState(0)

  const [unavailablePoint, setUnavailablePoint] = useState(null)

  const [stockConfirmationFailure, setStockConfirmationFailure] = useState(null)

  const [isConfirmingStock, setIsConfirmingStock] = useState(false)

  const stockReservation = useRef(null)

  const [selectedPointHasStockBreakdown, setSelectedPointHasStockBreakdown] = useState(false)

  const [confirmedPoint, setConfirmedPoint] = useState(null)

  const [stockOriginDiagnostics, setStockOriginDiagnostics] = useState(null)

  const [savedUserAddress, setSavedUserAddress] = useState(null)

  const [customerId, setCustomerId] = useState(null)

  const [isGetnetPopupResponseHandlerSet, setIsGetnetPopupResponseHandlerSet] = useState(false)

  const [naizConsumerHash, setNaizConsumerHash] = useState(null)

  const [parentUrl, setParentUrl] = useState('')

  const setData = (data) => {
    setSteps(data.steps)
    setSelectedShippingMethod(data.selectedShippingMethod)
    setCurrentStep(data.currentStep)
    setUserInfo(data.userInfo)
    setAddressInfo(data.addressInfo)
    setCustomerInfo(data.customerInfo)
    setEcommerceInfo(data.ecommerceInfo)
    setCompanyInfo(data.companyInfo)
    setCartData(data.cartData)
    setDiscountInfo(data.discountInfo)
    setSelectedServiceType(data.selectedServiceType)
    setDeliveryInfo(data.deliveryInfo)
    setBillingInfo(data.billingInfo)
    setLoaderInfo(data.loaderInfo)
  }

  const [isMarketingCheckboxChecked, setIsMarketingCheckboxChecked] = useState(null)

  const [isTermsCheckboxChecked, setIsTermsCheckboxChecked] = useState(false)

  const [forceScraperReload, setForceScraperReload] = useState(false)

  const [rechargeInfo, setRechargeInfo] = useState({ variantId: null, amount: 0 })
  const rechargeSyncRef = useRef(Promise.resolve())

  const [scraperAssignment, setScraperAssignment] = useState(null)

  const [didFallbackFromContainer, setDidFallbackFromContainer] = useState(false)

  const [uuidConnection] = useState(() => uuidv4())

  return (
    <DataContext.Provider
      value={{
        steps,
        setSteps,
        currentStep,
        setCurrentStep,
        userInfo,
        setUserInfo,
        ecommerceInfo,
        setEcommerceInfo,
        showFinalLoader,
        setShowFinalLoader,
        finalLoaderStartedAt,
        cartData,
        setCartData,
        addressInfo,
        setAddressInfo,
        selectedShippingMethod,
        setSelectedShippingMethod,
        isPickup,
        setIsPickup,
        isRefreshingDiscounts,
        setIsRefreshingDiscounts,
        isPosPaymentFlow,
        setIsPosPaymentFlow,
        isNewSession,
        setIsNewSession,
        posCredentialId,
        setPosCredentialId,
        posCourierPointId,
        setPosCourierPointId,
        pointsData,
        setPointsData,
        cartNotes,
        setCartNotes,
        isCartNotesActive,
        setIsCartNotesActive,
        billingInfo,
        setBillingInfo,
        cmsPaymentMethods,
        setCmsPaymentMethods,
        configurations,
        setConfigurations,
        shopifyLocations,
        setShopifyLocations,
        companyInfo,
        setCompanyInfo,
        loaderInfo,
        setLoaderInfo,
        selectedServiceType,
        setSelectedServiceType,
        deliveryInfo,
        setDeliveryInfo,
        giftNotes,
        setGiftNotes,
        isGiftWrapping,
        setIsGiftWrapping,
        isSummaryOpen,
        setIsSummaryOpen,
        isRemoved,
        setIsRemoved,
        customerInfo,
        setCustomerInfo,
        isSaving,
        setIsSaving,
        parentUrl,
        setParentUrl,
        isEditing,
        setIsEditing,
        isShowingMap,
        setIsShowingMap,
        isUserValidated,
        setIsUserValidated,
        options,
        setOptions,
        collectedScrapperInfo,
        setCollectedScrapperInfo,
        isAddingAddress,
        setIsAddingAddress,
        count,
        setCount,
        discountInfo,
        setDiscountInfo,
        isEditingDiscountCode,
        setIsEditingDiscountCode,
        isLoadingLoaderInfo,
        setIsLoadingLoaderInfo,
        orderData,
        setOrderData,
        cardsData,
        setCardsData,
        oneClick,
        setOneClick,
        otpChannel,
        setOtpChannel,
        abandonedCartData,
        setAbandonedCartData,
        extraAttributesShopify,
        setExtraAttributesShopify,
        abandonedCart,
        setAbandonedCart,
        abandonedCartProductsWithoutStock,
        setAbandonedCartProductsWithoutStock,
        paymentSuccessfulData,
        setPaymentSuccessfulData,
        clientMetaData,
        setClientMetaData,
        emptyCart,
        setEmptyCart,
        isProccessingPaymentLoader,
        setIsProccessingPaymentLoader,
        redirectReason,
        setRedirectReason,
        redirectSuccess,
        setRedirectSuccess,
        isReturningFromPaymentRedirect,
        setIsReturningFromPaymentRedirect,
        dataAndPaymentStateSetted,
        setDataAndPaymentStateSetted,
        encryptedMessage,
        setEncryptedMessage,
        isProductSoldOut,
        setIsProductSoldOut,
        isShowingRedirectModal,
        setIsShowingRedirectModal,
        hasToRedirect,
        setHasToRedirect,
        redirectExtraData,
        setRedirectExtraData,
        isUserLoggedIn,
        setIsUserLoggedIn,
        setData,
        isUserVerified,
        setIsUserVerified,
        isOtpOneClickSent,
        setIsOtpOneClickSent,
        userOneClickToken,
        setUserOneClickToken,
        useOneClickStep,
        setUseOneClickStep,
        addressId,
        setAddressId,
        isDeliveryDataChanged,
        setIsDeliveryDataChanged,
        stockBreakdownReloadAttempts,
        setStockBreakdownReloadAttempts,
        selectedPointHasStockBreakdown,
        setSelectedPointHasStockBreakdown,
        confirmedPoint,
        setConfirmedPoint,
        stockOriginDiagnostics,
        setStockOriginDiagnostics,
        unavailablePoint,
        setUnavailablePoint,
        stockConfirmationFailure,
        setStockConfirmationFailure,
        isConfirmingStock,
        setIsConfirmingStock,
        stockReservation,
        savedUserAddress,
        setSavedUserAddress,
        customerId,
        setCustomerId,
        isGetnetPopupResponseHandlerSet,
        setIsGetnetPopupResponseHandlerSet,
        naizConsumerHash,
        setNaizConsumerHash,
        isMarketingCheckboxChecked,
        setIsMarketingCheckboxChecked,
        isTermsCheckboxChecked,
        setIsTermsCheckboxChecked,
        forceScraperReload,
        setForceScraperReload,
        rechargeInfo,
        setRechargeInfo,
        rechargeSyncRef,
        earlyScraperResponse,
        setEarlyScraperResponse,
        isWaitingStepThree,
        setIsWaitingStepThree,
        scraperAssignment,
        setScraperAssignment,
        didFallbackFromContainer,
        setDidFallbackFromContainer,
        scraperStartTime,
        setScraperStartTime,
        uuidConnection
      }}
    >
      {children}
    </DataContext.Provider>
  )
}

DataProvider.propTypes = {
  children: PropTypes.node.isRequired
}
